import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const response = await authAPI.getMe();
        setUser(response.data.user);
        setProfile(response.data.profile);
      } catch (error) {
        localStorage.removeItem('token');
      }
    }
    setLoading(false);
  };

  const login = async (identifier, password) => {
    const response = await authAPI.login({ identifier, password });
    localStorage.setItem('token', response.data.token);
    setUser(response.data.user);
    await checkAuth();
    return response.data;
  };

  const register = async (data) => {
    const response = await authAPI.register(data);
    localStorage.setItem('token', response.data.token);
    setUser(response.data.user);
    await checkAuth();
    return response.data;
  };

  const googleLogin = async (credential, userType) => {
    const response = await authAPI.googleAuth({ credential, userType });
    localStorage.setItem('token', response.data.token);
    setUser(response.data.user);
    await checkAuth();
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    setProfile(null);
    window.location.href = '/';
  };

  const refreshProfile = async () => {
    try {
      const response = await authAPI.getMe();
      setProfile(response.data.profile);
    } catch (error) {
      console.error('Failed to refresh profile');
    }
  };

  const value = {
    user,
    profile,
    loading,
    login,
    register,
    googleLogin,
    logout,
    refreshProfile,
    isAuthenticated: !!user,
    isClient: user?.userType === 'client',
    isAttorney: user?.userType === 'attorney',
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
